var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWindSpeed01Old = function SvgWindSpeed01Old(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wind_speed-01_old_svg2__a",
    x1: -12.51,
    x2: 127.35,
    y1: 114.19,
    y2: 8.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#wind_speed-01_old_svg2__a",
    id: "wind_speed-01_old_svg2__b",
    x1: 15.04,
    x2: 154.9,
    y1: 150.73,
    y2: 45.32
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#wind_speed-01_old_svg2__a",
    id: "wind_speed-01_old_svg2__c",
    x1: 59.1,
    x2: 198.96,
    y1: 209.2,
    y2: 103.78
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#wind_speed-01_old_svg2__a",
    id: "wind_speed-01_old_svg2__d",
    x1: 59.96,
    x2: 199.82,
    y1: 210.33,
    y2: 104.92
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#wind_speed-01_old_svg2__a",
    id: "wind_speed-01_old_svg2__e",
    x1: -11.11,
    x2: 128.74,
    y1: 116.03,
    y2: 10.62
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M21.45 76.5c-6.66 0-12.09 5.42-12.09 12.09s5.42 12.09 12.09 12.09 12.09-5.42 12.09-12.09S28.12 76.5 21.45 76.5m0 19.17c-3.91 0-7.09-3.18-7.09-7.09s3.18-7.09 7.09-7.09 7.09 3.18 7.09 7.09-3.18 7.09-7.09 7.09",
    style: {
      fill: "url(#wind_speed-01_old_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.15 154.47h-.49l-.26-5.81a2.5 2.5 0 0 0-2.61-2.38 2.49 2.49 0 0 0-2.38 2.61l.25 5.58H74.7l1.99-54.95c.79.36 1.63.63 2.51.81v6.59c0 .9.37 1.78 1.03 2.4.62.59 1.45.93 2.31.93h.14c1.36-.06 2.68-.26 3.96-.55l1.26 27.97a2.506 2.506 0 0 0 2.5 2.39h.11a2.49 2.49 0 0 0 2.38-2.61l-1.34-29.55c6.32-3.23 10.81-9.45 11.64-16.79h17.19c1.24 10.78 10.42 19.17 21.52 19.17 11.95 0 21.67-9.72 21.67-21.67s-9.72-21.67-21.67-21.67c-11.1 0-20.28 8.4-21.52 19.17h-17.19c-1.2-10.45-9.78-18.67-20.53-19.15-.9-.04-1.8.29-2.46.92a3.35 3.35 0 0 0-1.03 2.41v6.59c-4.67.96-8.33 4.62-9.31 9.23H42.97c-.3-2.58-1.06-5.09-2.24-7.39a2.502 2.502 0 0 0-4.45 2.29c1.21 2.37 1.83 4.92 1.83 7.6 0 9.19-7.48 16.67-16.67 16.67S4.77 97.8 4.77 88.61s7.48-16.67 16.67-16.67c2.93 0 5.81.77 8.33 2.23 1.19.69 2.73.28 3.42-.91.69-1.2.28-2.72-.91-3.42a21.65 21.65 0 0 0-10.84-2.9C9.5 66.92-.22 76.64-.22 88.59s9.72 21.67 21.67 21.67c11.1 0 20.28-8.4 21.52-19.17h26.89c.35 1.62 1.02 3.11 1.95 4.42l-2.13 58.96h-.46c-5.96 0-10.81 4.85-10.81 10.81v.48c0 1.82 1.48 3.3 3.3 3.3h39.94c1.82 0 3.3-1.48 3.3-3.3v-.48c0-5.96-4.85-10.81-10.81-10.81Zm47.77-82.55c9.19 0 16.67 7.48 16.67 16.67s-7.48 16.67-16.67 16.67-16.67-7.48-16.67-16.67 7.48-16.67 16.67-16.67m-57.73.18c8.07 1.2 14.17 8.14 14.17 16.49s-6.1 15.28-14.17 16.49V72.11Zm-5 9.93v13.12c-2.68-.98-4.59-3.57-4.59-6.56s1.9-5.57 4.59-6.56m-15.64 82.02c.56-2.62 2.9-4.58 5.68-4.58h24.92c2.78 0 5.12 1.97 5.68 4.58z",
    style: {
      fill: "url(#wind_speed-01_old_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.66 139.71h-35.6c-1.66 0-3 1.34-3 3s1.34 3 3 3h35.6c4.05 0 7.35 3.3 7.35 7.35s-3.3 7.35-7.35 7.35a7.29 7.29 0 0 1-5.88-2.94c-.99-1.33-2.87-1.59-4.2-.6a3.01 3.01 0 0 0-.6 4.2c2.55 3.39 6.44 5.34 10.68 5.34 7.36 0 13.35-5.99 13.35-13.35s-5.99-13.35-13.35-13.35",
    style: {
      fill: "url(#wind_speed-01_old_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.91 119.5h-51.74c-1.66 0-3 1.34-3 3s1.34 3 3 3h51.74c4.05 0 7.35 3.3 7.35 7.35s-3.3 7.35-7.35 7.35a7.29 7.29 0 0 1-5.88-2.94 3 3 0 0 0-4.2-.6 3.01 3.01 0 0 0-.6 4.2c2.55 3.39 6.44 5.34 10.68 5.34 7.36 0 13.35-5.99 13.35-13.35s-5.99-13.35-13.35-13.35",
    style: {
      fill: "url(#wind_speed-01_old_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.39 36.9h60.02c4.05 0 7.35 3.3 7.35 7.35s-3.3 7.35-7.35 7.35a7.29 7.29 0 0 1-5.88-2.94 3.01 3.01 0 0 0-4.2-.6c-1.33 1-1.59 2.88-.6 4.2 2.55 3.39 6.44 5.34 10.68 5.34 7.36 0 13.35-5.99 13.35-13.35s-5.99-13.35-13.35-13.35H52.39c-1.66 0-3 1.34-3 3s1.34 3 3 3",
    style: {
      fill: "url(#wind_speed-01_old_svg2__e)"
    }
  }));
};
export default SvgWindSpeed01Old;